export default {
    buttons: {
        reset_password: 'Reset Password',
    },
    fields: {
        email: {
            label: 'Email',
            placeholder: "john.jonhson{'@'}myemail.com",
        },
    },
    errors: {
        email_not_exist: 'Email does not exist',
    },
}
